import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'
import {initialState} from './index'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload, result) {
  return {
    ...state,
    moduleSettings: result,
    isLoading: false,
  }
}

export function rejected() {
  return initialState
}

export async function action() {
  try {
    return await Api.getUserModuleSettings()
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
